import { ChangeContext, Options } from '@angular-slider/ngx-slider';
import { Component, OnInit } from '@angular/core';
import { ContentElement, ContentStatusEnum } from '@urbannex/storethemes';
import { CellEditorStoreService } from '../../cell-editor-store.service';
import { SectionBuilderStoreService } from '../../sections-editor/shared-section-builder/section-builder-store.service';
import { EditState } from '../../../model';

interface FontWeight {
  name: string;
  value: number;
}

@Component({
  selector: 'ngx-font-weight-popover',
  templateUrl: './font-weight-popover.component.html',
  styleUrls: ['./font-weight-popover.component.scss']
})
export class FontWeightPopoverComponent implements OnInit {
  weights: FontWeight[] = [
    {name:"Normal",value:400},
    {name:"Bold",value:600},
    {name:"Bolder",value:700}
  ]
  content:ContentElement;
  title:string;
  status:ContentStatusEnum;
  /**
   * Service passed in via popoverContext
   * This is used to determine which service to use for updating the content.
   * options are:
   * 1. cellEditor - used for content in the cell editor
   * 2. sectionEditor - used for content in the section editor
   * 2. default - when no service is passed
   */
  service:string;

  currentValue;
  target:string;
  height;
  value: number = 0;
  options: Options = {};
  optionsSet = false;
  
  constructor(private cellEditorStoreService:CellEditorStoreService,
    private sectionBuilderStoreService:SectionBuilderStoreService) { }

  ngOnInit(): void {
    this.options = {
      floor: 0,
      ceil: 2,
      step:1,
      showTicks: true,
      translate: (value: number): string => {
        return this.weights[value].name;
      },
/*       getLegend: (value: number): string => {
        return this.weights[value].name;
      }, */
      selectionBarGradient: {
        from: 'white',
        to: '#10248A'
      }
    }
    //this.options.ceil = this.weights.length;
    this.optionsSet = true;
    if(this.content.fontWeight){
      let valueObject = this.weights.find(weight => <any><number>weight.value === this.content.fontWeight);
      if(valueObject){
        this.value = valueObject.value
      }
      //this.value = this.weights.findIndex(weight => <any><number>weight.value === this.content.fontWeight)+1;
    }else{
      this.value = this.weights[0].value
    }
    if(this.status){
      switch (this.status) {
        case ContentStatusEnum.CTNT_INITIAL_DRAFT:
          this.service = "sectionBuilder";
          break;
        case ContentStatusEnum.CTNT_FINAL_DRAFT:
          this.service = "cellEditor";
          break;      
        default:
          this.service = undefined
          break;
      }
    }else{
      this.service = "cellEditor"
    }

  }
  onUserChange(changeContext: ChangeContext){
    console.log(changeContext.value);
    //this.marginBottom = changeContext.value;
  }
  onUserChangeStart(changeContext: ChangeContext){
    this.sectionBuilderStoreService.updateEditState(EditState.EDITING)
    console.log({start:changeContext.value})
  }

  onUserChangeEnd(changeContext: ChangeContext){
    console.log({end:changeContext.value});
    console.log(this.weights[changeContext.value  - 1]);
    let choice = this.weights[changeContext.value  - 1];
    this.content.fontWeight = <any><number>choice.value;
    if(this.service == "cellEditor"){
      this.cellEditorStoreService.contentElements$.subscribe((contentElements:ContentElement[]) => {
        let contentElement = contentElements.find(element => element.elId == this.content.elId);
        contentElement.fontWeight = <any><number>choice.value;
        this.cellEditorStoreService.updateContentElements(contentElements);
      });
    }else if(this.service == "sectionBuilder"){
      this.sectionBuilderStoreService.updateContent(this.content);
      this.sectionBuilderStoreService.updateEditState(EditState.UPDATED)
    }else{
      if(this.content){
        this.content.fontWeight = <any><number>choice.value;
      }
    }
    
    
  }

  

  onSubmit(){
    //this.sectionEditorStoreService.updateMarginBottom(this.marginBottom);
  }

}
